import {Injectable} from '@angular/core';
import {BehaviorSubject} from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class ChatNewMessageIndicatorService {
    private readonly isVisible = new BehaviorSubject<boolean>(false);
    public readonly isVisible$ = this.isVisible.asObservable();

    public show(): void {
        this.isVisible.next(true);
    }

    public reset(): void {
        this.isVisible.next(false);
    }
}
